"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCSRFTokenCheck = void 0;
const cookie_1 = require("cookie");
const constants_1 = require("./constants");
const cookies_1 = require("./cookies");
const hmac_1 = require("./hmac");
const createCSRFTokenCheck = ({ headerName, cookieName, isSigned, deleteMismatchedCookie }) => (handler) => async (req, res) => {
    if (!req.headers?.cookie) {
        return res.status(constants_1.FORBIDDEN_CODE).json({ message: constants_1.ERROR_MESSAGE });
    }
    const cookies = (0, cookie_1.parse)(req.headers?.cookie);
    const cookieValue = cookies[cookieName];
    if (!cookieValue) {
        return res.status(constants_1.FORBIDDEN_CODE).json({ message: constants_1.ERROR_MESSAGE });
    }
    // Form https://www.w3.org/Protocols/rfc2616/rfc2616.html headers are case insensitive, and are lower-cased.
    // This is not true for other frameworks, and django will still use X-CSRFToken
    const tokenFromHeader = req.headers[headerName.toLowerCase()];
    if (!tokenFromHeader) {
        return res.status(constants_1.FORBIDDEN_CODE).json({ message: constants_1.ERROR_MESSAGE });
    }
    const tokenFromCookie = isSigned ? await (0, cookies_1.unSign)(cookieValue) : cookieValue;
    if (!tokenFromCookie || !(0, hmac_1.timeSafeCompare)(tokenFromCookie, tokenFromHeader)) {
        // setting empty cookie to reset the cookie in case of a mismatch: trying again would regenerate the token
        if (deleteMismatchedCookie) {
            (0, cookies_1.setCookie)(res, cookieName, "");
        }
        return res.status(constants_1.FORBIDDEN_CODE).json({ message: constants_1.ERROR_MESSAGE });
    }
    return handler(req, res);
};
exports.createCSRFTokenCheck = createCSRFTokenCheck;
//# sourceMappingURL=createCSRFTokenCheck.js.map